var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_2649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2444 23.6829L20.2754 23.2743M20.2754 20.8181L19.2444 20.4084M22.0894 19.0809L21.6616 18.0935M22.0894 25.0116L21.6616 26M24.6539 19.0809L25.0817 18.0935M25.0806 26L24.6539 25.0116M18.9441 18.0935C17.2283 16.8087 14.3932 16.593 13.005 16.8087C11.6168 17.0243 10.3014 17.5507 9.16572 18.3451C8.03003 19.1394 7.10612 20.1793 6.46915 21.38C5.83218 22.5808 5.50013 23.9086 5.5 25.2555H17.2283M26.4679 20.8181L27.5 20.4084M26.4679 23.2743L27.5 23.684M20.0207 11.3487C20.0207 14.3028 17.5203 16.6975 14.4358 16.6975C11.3514 16.6975 8.85093 14.3028 8.85093 11.3487C8.85093 8.39471 11.3514 6 14.4358 6C17.5203 6 20.0207 8.39471 20.0207 11.3487ZM26.7226 22.0462C26.7226 23.8186 25.2223 25.2555 23.3716 25.2555C21.521 25.2555 20.0207 23.8186 20.0207 22.0462C20.0207 20.2738 21.521 18.837 23.3716 18.837C25.2223 18.837 26.7226 20.2738 26.7226 22.0462Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_2649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserw);
export default __webpack_public_path__ + "static/media/userw.833861a2e614821ff0340efdd46a0dca.svg";
export { ForwardRef as ReactComponent };